import { defineStore } from 'pinia';

import {
  CampaignRepository,
  CampaignDetailResponse,
} from '@/repositories/generated';
import { EditCampaignForm } from '@/validations';

type CampaignState = {
  form: EditCampaignForm | undefined;
  initData: CampaignDetailResponse | undefined;
};

export const useEditCampaignStore = defineStore('editCampaign', {
  state: (): CampaignState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    async changeEndDate() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await CampaignRepository.changeEndDate({
        id: initData.id,
        requestBody: {
          endDateTime: form.endDateTime.toISOString(),
        },
      });
    },
    async getEditCampaign(id: string) {
      this.$reset();

      const res = await CampaignRepository.detail({ id });
      this.initData = res;

      return res;
    },
    setUiForm(form: EditCampaignForm) {
      this.form = {
        startDateTime: form.startDateTime,
        endDateTime: form.endDateTime,
      };
    },
  },
});
